import { render } from "./BoardDocs.vue?vue&type=template&id=418fbfff"
import script from "./BoardDocs.vue?vue&type=script&lang=js"
export * from "./BoardDocs.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__